import { createApi } from "@reduxjs/toolkit/query/react";
import { createBaseApiWithAuth } from "@/utilities/reduxToolkit";

export const ocrApi = createApi({
  ...createBaseApiWithAuth({
    reducerPath: "ocrApi",
    baseUrl: "/api/ocr",
  }),
  reducerPath: "ocrApi",
  tagTypes: ["OCR"],
  endpoints: (builder) => ({
    processOCR: builder.mutation<any, {
      file: File;
      documentType: string;
      documentTemplateId?: string;
      batchName?: string;
      batchDescription?: string;
      batchId?: string;
      enableSmartFields?: boolean;
      companyId?: string;
    }>({
      query: ({ file, documentType, documentTemplateId, batchName, batchDescription, batchId, enableSmartFields = true, companyId }) => {
        const formData = new FormData();
        formData.append("file", file);
        formData.append("documentType", documentType);
        formData.append("enableSmartFields", String(enableSmartFields));
        if (companyId) {
          formData.append("companyId", companyId);
        }

        if (documentTemplateId) {
          formData.append("documentTemplateId", documentTemplateId);
        }
        if (batchName) {
          formData.append("batchName", batchName);
        }
        if (batchDescription) {
          formData.append("batchDescription", batchDescription);
        }
        if (batchId) {
          formData.append("batchId", batchId);
        }

        return {
          url: "/process-ocr",
          method: "POST",
          body: formData,
        };
      },
      invalidatesTags: ["OCR"],
    }),
    processStoredFile: builder.mutation<
      any,
      { fileId: string; folder: string; documentType: string }
    >({
      query: ({ fileId, folder, documentType }) => ({
        url: "/process-ocr-stored",
        method: "POST",
        body: { fileId, folder, documentType },
      }),
      invalidatesTags: ["OCR"],
    }),
  }),
});

export const {
  useProcessOCRMutation,
  useProcessStoredFileMutation,
} = ocrApi;
